module.exports = __webpack_public_path__ + "img/324.3cdabee3.jpg";